function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? module.exports = t(require("lodash/isBoolean"), require("lodash/isElement"), require("@djforth/viewport-detection-fp")) : "function" == typeof define && define.amd ? define(["lodash/isBoolean", "lodash/isElement", "@djforth/viewport-detection-fp"], t) : e.VanillaResponsiveNavigation = t(e._isBoolean, e._isElement, e.ViewportDetect);
}(this, function (e, t, i) {
  "use strict";

  e = e && e.hasOwnProperty("default") ? e.default : e, t = t && t.hasOwnProperty("default") ? t.default : t, i = i && i.hasOwnProperty("default") ? i.default : i;

  var n = function () {
    function e(e, t) {
      for (var i, n = 0; n < t.length; n++) {
        (i = t[n]).enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
      }
    }

    return function (t, i, n) {
      return i && e(t.prototype, i), n && e(t, n), t;
    };
  }();

  var s = function () {
    function s(e) {
      var i = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {};
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, s);
      var n = document.getElementById(e);
      t(n) && (this.config = Object.assign({
        dropdown_class: "dropdown-parent",
        flyout: !1,
        list_id: "responsive-navigation-list",
        toggle_id: "responsive-navigation-toggle",
        toggle_mobile_id: null
      }, i));
    }

    return n(s, [{
      key: "_init",
      value: function value() {
        this._initViewport(), this.dropdownParents = [], this.dropdownToggles = [], this.list = document.getElementById(this.config.list_id), this.toggle = document.getElementById(this.config.toggle_id), this.toggleMobile = document.getElementById(this.config.toggle_mobile_id), this._render();
      }
    }, {
      key: "_initViewport",
      value: function value() {
        var e = this;
        this.vpDetect = i(), this.device = this.vpDetect.getDevice(), this.vpDetect.addCallback(function (t) {
          e._trackSize(t);
        });
      }
    }, {
      key: "_render",
      value: function value() {
        this.config.flyout && this._getBodyClass(), this._addToggleListener(), this._getDropdownParents(), this._hideNav(), this._setToggleAriaHidden(!this._deviceCheck());
      }
    }, {
      key: "_addDropdownHoverListener",
      value: function value(e) {
        e.addEventListener("mouseover", this._setDropdownAriaHiddenDesktop.bind(this, e), !1), e.addEventListener("mouseout", this._setDropdownAriaHiddenDesktop.bind(this, e), !1);
      }
    }, {
      key: "_addDropdownToggleClickListener",
      value: function value(e) {
        e.addEventListener("click", this._dropdownToggleClick.bind(this), !1);
      }
    }, {
      key: "_addToggleListener",
      value: function value() {
        this.toggle.addEventListener("click", this._toggleClick.bind(this), !1), null !== this.toggleMobile && this.toggleMobile.addEventListener("click", this._toggleClick.bind(this), !1);
      }
    }, {
      key: "_deviceCheck",
      value: function value() {
        return "mobile" === this.device || "tablet" === this.device;
      }
    }, {
      key: "_dropdownToggleClick",
      value: function value(e) {
        e.preventDefault(), this._deviceCheck() && (this._toggleDropdown(e.target), this._setDropdownAriaHiddenMobile(e.target));
      }
    }, {
      key: "_getBodyClass",
      value: function value() {
        this.body = document.body, this.bodyClass = this.body.className;
      }
    }, {
      key: "_getDropdownParents",
      value: function value() {
        var e = this,
            t = this.list.getElementsByTagName("li");
        this.dropdownParents = Array.from(t).filter(function (t) {
          return t.className === e.config.dropdown_class;
        }), this.dropdownParents.forEach(this._addDropdownHoverListener.bind(this)), this._getDropdownToggles();
      }
    }, {
      key: "_getDropdownToggles",
      value: function value() {
        var e = this;
        this.dropdownToggles = this.dropdownParents.map(function (t) {
          return e._skipTextNodes(t, "firstChild");
        }), this.dropdownToggles.forEach(this._addDropdownToggleClickListener.bind(this));
      }
    }, {
      key: "_hideNav",
      value: function value(t) {
        this.hideMenu = e(t) ? t : !!this._deviceCheck() && !this.hideMenu, this.config.flyout && this._setBodyClass(this.hideMenu), this._setListClass(this.hideMenu), this._setToggleAriaExpanded(this.hideMenu);
      }
    }, {
      key: "_resetDropdownParentsStates",
      value: function value() {
        var e, t;
        this.dropdownToggles.forEach(function (t) {
          e = t.className, t.className = e.replace(/(?:^|\s)open(?!\S)/g, "");
        }), this.dropdownParents.forEach(function (e) {
          (t = e.getElementsByTagName("ul")[0]).style.display = "none", t.setAttribute("aria-hidden", "true");
        });
      }
    }, {
      key: "_setBodyClass",
      value: function value(e) {
        this.body.className = e ? this.bodyClass : this.bodyClass + " nav-open";
      }
    }, {
      key: "_setDropdownAriaHiddenDesktop",
      value: function value(e) {
        if (!this._deviceCheck()) {
          var t = e.getElementsByTagName("ul")[0];
          t.setAttribute("aria-hidden", null === t.offsetParent ? "true" : "false");
        }
      }
    }, {
      key: "_setDropdownAriaHiddenMobile",
      value: function value(e) {
        var t = this._skipTextNodes(e, "nextSibling");

        t.setAttribute("aria-hidden", null === t.offsetParent ? "true" : "false");
      }
    }, {
      key: "_setListClass",
      value: function value(e) {
        var t = this.list.className;
        this.list.className = t.replace(/(?:^|\s)open(?!\S)/g, ""), e || (this.list.className += " open");
      }
    }, {
      key: "_setToggleAriaExpanded",
      value: function value(e) {
        this.toggle.setAttribute("aria-expanded", e ? "false" : "true");
      }
    }, {
      key: "_setToggleAriaHidden",
      value: function value(e) {
        this.toggle.setAttribute("aria-hidden", e ? "true" : "false");
      }
    }, {
      key: "_skipTextNodes",
      value: function value(e, t) {
        for (var i = e[t]; null !== i && 1 !== i.nodeType;) {
          i = i.nextSibling;
        }

        return element;
      }
    }, {
      key: "_toggleClick",
      value: function value(e) {
        e.preventDefault(), this._hideNav();
      }
    }, {
      key: "_toggleDropdown",
      value: function value(e) {
        var t = e.className,
            i = this._skipTextNodes(e, "nextSibling");

        null === i.offsetParent ? (i.style.display = "block", e.className += " open") : (i.style.display = "none", e.className = t.replace(/(?:^|\s)open(?!\S)/g, ""));
      }
    }, {
      key: "_trackSize",
      value: function value(e) {
        this._resetDropdownParentsStates(), this.device !== e && (this.device = e), this._deviceCheck() ? (this._hideNav(!0), this._setToggleAriaHidden(!1)) : (this._hideNav(!1), this._setToggleAriaHidden(!0));
      }
    }]), s;
  }();

  return module.exports = exports.default, s;
});